<template>
  <div class="public-content recharge-enquiry">
    <div class="breadcrumb">提现明细</div>
    <div class="right-main">
      <el-form :inline="true" :model="formInline" label-width="80px" class="demo-form-inline">
        <el-row>
          <el-col :span="6">
            <el-form-item label="业务:">
              <el-select clearable v-model="formInline.salesmanId" :filter-method="selectSalemanList" filterable placeholder="请输入业务名称">
                <el-option v-for="item in salemanList" :key="item.id" :label="item.fullName" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="平台号:">
              <el-select clearable v-model="formInline.storeId" :filter-method="filterMethod" filterable placeholder="请输入平台号">
                <el-option v-for="item in storeListByCode" :key="item.id" :label="item.code" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="平台名称:">
              <el-select clearable v-model="formInline.storeId" :filter-method="filterByName" filterable placeholder="请输入平台名称">
                <el-option v-for="item in storeListByCode" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="交易状态:">
              <el-select v-model="formInline.tradeStatus" clearable placeholder="请选择">
                <el-option label="" value="">全部</el-option>
                <!-- <el-option v-for="(v, k) in $config.tradeStatus" :key='k' :label="v" :value="k"></el-option> -->
                <el-option v-for="(v, k) in $config.cashoutTradeStatus" :key='k' :label="v" :value="k"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="申请日期:" class="el-date-width">
              <el-date-picker v-model="value2" type="daterange" format="yyyy-MM-dd" value-format="yyyy-MM-dd" :clearable="true" align="left" unlink-panels range-separator="至" start-placeholder="请选择开始日期"
                end-placeholder="请选择结束日期" :picker-options="pickerOptions">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6" class="fn-right form-btn">
            <el-button class="search-ok" @click="onSubmit(1)" round>查询</el-button>
            <el-button class="search-ok" @click="exportExcel" round>导出Excel</el-button>
          </el-col>
        </el-row>
      </el-form>
      <div class="data-list">
        <el-table :data="tableData" :row-class-name="rowClassName" border style="width: 100%">
          <el-table-column label="流水号" fixed="left" min-width="210px">
            <template v-slot="scope">
              <span v-if='$hasPermission("epay:admin:cashout:audit")' class="color-blue" @click="goPath(scope.row)">{{ scope.row.refundNo }}</span>
              <span v-else>{{ scope.row.refundNo }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="amount" label="提现金额" min-width="100"></el-table-column>
          <el-table-column prop="dateCreated" label="申请日期" min-width="180"></el-table-column>
          <el-table-column label="支付方式" prop="paymentType">
            <template slot-scope="scope"> {{ $config.paymentTypes[scope.row.paymentType] }} </template>
          </el-table-column>
          <el-table-column label="支付日期" prop="paymentDate" min-width="170"></el-table-column>
          <el-table-column prop="paymentStatus" label="支付状态">
            <template slot-scope="scope"> {{ $config.paymentStatus[scope.row.paymentStatus] }} </template>
          </el-table-column>
          <el-table-column label="交易状态" prop="tradeStatus">
            <template slot-scope="scope"> {{ $config.cashoutTradeStatus[scope.row.tradeStatus] || scope.row.tradeStatus }}
              <!-- {{ scope.row.tradeStatus==='APPLY'?'未审核':scope.row.tradeStatus==='REJECTED'?'审核拒绝':scope.row.tradeStatus==='AUDITED'?'财务审核':scope.row.tradeStatus==='CASHSED_OUT'?'已提现':scope.row.tradeStatus==='APPLIED'?'申请提现':scope.row.tradeStatus==='INVOICED'?'已开发票':'未定义' }} -->
            </template>
          </el-table-column>
          <el-table-column prop="store.code" label="平台号" min-width="100"></el-table-column>
          <el-table-column prop="store.name" label="平台名称" min-width="110"></el-table-column>
          <el-table-column prop="store.salesman.fullName" label="业务" min-width="120"></el-table-column>
          <!--          <el-table-column prop="paymentStatus" label="提现状态" min-width="180"></el-table-column>-->
          <el-table-column label="操作" min-width="120px">
            <template v-slot="scope">
              <span class="color-blue" v-if="scope.row.tradeStatus === 'APPLY' && $hasPermission('epay:admin:cashout:audit')" @click="handleCashout('audit', scope.row)"
                ref="operationRef">财务审核<br></span>
              <span class="color-blue" v-if="scope.row.tradeStatus === 'AUDITED' && $hasPermission('epay:admin:cashout:invoice')" @click="handleCashout('invoice', scope.row)"
                ref="operationRef">收发票<br></span>
              <span class="color-blue" v-if="scope.row.tradeStatus === 'INVOICED' && $hasPermission('epay:admin:cashout:cashout')" @click="handleCashout('cashout', scope.row)"
                ref="operationRef">打款<br></span>
              <span class="color-blue" v-if="!['APPLY', 'AUDITED', 'INVOICED'].includes(scope.row.tradeStatus) && $hasPermission('epay:admin:cashout:audit')" @click="goPath(scope.row)"
                ref="operationRef">详情<br></span>
              <!--              <span class="color-blue" v-if="scope.row.cashoutStatus === 'AUDITED'"-->
              <!--                    @click="$router.push({path: '/cashoutAudit',query: { id: scope.row.cashoutId, code: 'invoice'}})" ref="operationRef">已开发票<br></span>-->
              <!--              <span class="color-blue" v-if="scope.row.cashoutStatus === 'INVOICED'"-->
              <!--                    @click="$router.push({path: '/cashoutAudit',query: { id: scope.row.cashoutId, code: 'cashout'}})" ref="operationRef">打款<br></span>-->
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页-->
      <v-pagination class="v-pagination" @changePage="changePage" :queryInfo='queryInfo'></v-pagination>
    </div>
    <!-- 已审核 -->
    <el-dialog :close-on-click-modal="false" title="操作日志" :visible.sync="dialogVisible" width="50%">
      <el-table :data="auditedData" style="width: 100%">
        <el-table-column prop="auditStatus" label="状态">
          <template slot-scope="scope">{{ $config.auditStatus[scope.row.auditStatus] }}</template>
        </el-table-column>
        <el-table-column prop="dateCreated" label="更新日期"></el-table-column>
        <el-table-column prop="userCreated" label="操作人"></el-table-column>
        <el-table-column prop="note" label="备注" min-width="100"></el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import VPagination from '@/components/Pagination/index.vue'
import { cashoutExport, getCashoutPage } from '@/api/epay'
import { storeQueryListByCode, getSalesmanByFullName, storeQueryListByName } from '@/api/crm'
export default {
  name: 'VpayCharge',
  components: {
    VPagination
  },
  data () {
    return {
      storeListByCode: [],
      storeListByName: [],
      salemanList: [],
      auditedData: [],
      dialogVisible: false,
      storeName: '',
      code: '',
      fullName: '',
      queryInfo: {
        total: 0,
        pageNum: 1,
        pageSize: 10
      },
      formInline: {
        // cashoutStatus: '',
        tradeStatus: '',
        dateEnd: '',
        dateStart: '',
        salesmanId: '',
        storeId: ''
      },
      handleTypes: '',
      tableData: [],
      value2: [
        this.$moment().subtract(6, 'months').format('YYYY-MM-DD'),
        this.$moment().format('YYYY-MM-DD')
      ],
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now() - 8.64e6
        },
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      }
    }
  },
  watch: {
    value2: {
      handler (val, oldVal) {
        if (val) {
          this.formInline.dateStart = val[0]
          this.formInline.dateEnd = val[1]
        } else {
          this.formInline.dateStart = ''
          this.formInline.dateEnd = ''
        }
      },
      deep: true,
      immediate: true
    }
  },
  created () {
    if (sessionStorage.getItem('searchFlag') === 'true') {
      this.formInline = JSON.parse(sessionStorage.getItem('queryParams'))
      this.queryInfo = JSON.parse(sessionStorage.getItem('queryInfo'))
      this.storeListByCode = JSON.parse(sessionStorage.getItem('storeListByCode'))
      this.salemanList = JSON.parse(sessionStorage.getItem('salemanList'))
      this.value2 = [this.formInline.dateStart, this.formInline.dateEnd]
      sessionStorage.removeItem('searchFlag')
    } else {
      // 首次进入列表页,清除缓存中的搜索条件
      sessionStorage.removeItem('queryParams')
      sessionStorage.removeItem('queryInfo')
      sessionStorage.removeItem('storeListByCode')
      sessionStorage.removeItem('salemanList')
    }
    this.onSubmit()
  },
  destroyed () {
    // 销毁
    console.log('页面销毁')
    sessionStorage.removeItem('searchFlag')
  },
  methods: {
    handleCashout (val, content) {
      sessionStorage.setItem('queryInfo', JSON.stringify(this.queryInfo))
      sessionStorage.setItem('queryParams', JSON.stringify(this.formInline))
      sessionStorage.setItem('storeListByCode', JSON.stringify(this.storeListByCode))
      sessionStorage.setItem('salemanList', JSON.stringify(this.salemanList))
      if (val === 'audit') {
        this.$router.push({ path: '/epay/cashoutAudit', query: { rowDate: JSON.stringify(content), handleType: 'audit' } })
      }
      if (val === 'invoice') {
        this.$router.push({ path: '/epay/cashoutAudit', query: { rowDate: JSON.stringify(content), handleType: 'invoice' } })
      }
      if (val === 'cashout') {
        this.$router.push({ path: '/epay/cashoutAudit', query: { rowDate: JSON.stringify(content), handleType: 'cashout' } })
      }
    },

    selectSalemanList (val) {
      if (val.trim()) {
        getSalesmanByFullName(val).then(res => {
          if (res.data.success) {
            this.salemanList = res.data.data
          }
        })
      }
    },
    filterByName (val) {
      if (val.trim()) {
        storeQueryListByName(val).then(res => {
          if (res.data.success) {
            this.storeListByCode = res.data.data
          }
        })
      }
    },
    filterMethod (val) {
      if (val.trim()) {
        storeQueryListByCode(val).then(res => {
          if (res.data.success) {
            this.storeListByCode = res.data.data
          }
        })
      }
    },
    onSubmit (num) {
      if (sessionStorage.getItem('searchFlag')) {
        sessionStorage.setItem('queryInfo', JSON.stringify(this.queryInfo))
        sessionStorage.setItem('queryParams', JSON.stringify(this.formInline))
        sessionStorage.setItem('storeListByCode', JSON.stringify(this.storeListByCode))
        sessionStorage.setItem('salemanList', JSON.stringify(this.salemanList))
      }
      let param = JSON.parse(JSON.stringify(this.formInline))
      this.queryInfo.pageNum = num || this.queryInfo.pageNum
      Object.keys(param).forEach((key) => (param[key] === '' || param[key] === null) && delete param[key])
      getCashoutPage({ data: param, params: { page: this.queryInfo.pageNum - 1, size: this.queryInfo.pageSize } })
        .then(res => {
          if (res.data.success) {
            this.queryInfo.total = res.data.data.total
            this.tableData = res.data.data.content.map(a => {
              return {
                ...a,
                amount: Math.floor(a.amount * 100) / 100
              }
            })
          }
        })
    },
    rowClassName ({ row, rowIndex }) {
      row.index = rowIndex
    },

    exportExcel () {
      const loading = this.$loading({
        lock: true,
        text: '正在导出表格，请稍后',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      let param = JSON.parse(JSON.stringify(this.formInline))
      Object.keys(param).forEach((key) => (param[key] === '' || param[key] === null) && delete param[key])
      cashoutExport(param).then(res => {
        let blob = res.data
        const fileReader = new FileReader()
        fileReader.readAsDataURL(blob)
        fileReader.onload = (event) => {
          let a = document.createElement('a')
          // let _fileName = '提现记录表' + this.$moment(new Date()).format('YYMMDDhmmss') + '.xls'
          let _fileName = '提现记录表' + this.formInline.dateStart + '-' + this.formInline.dateEnd + '.xls'
          a.download = _fileName
          a.href = event.target.result
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
          loading.close()
        }
      })
    },
    changePage (val) {
      this.queryInfo = val
      this.onSubmit()
    },
    goPath (row) {
      sessionStorage.setItem('queryInfo', JSON.stringify(this.queryInfo))
      sessionStorage.setItem('queryParams', JSON.stringify(this.formInline))
      sessionStorage.setItem('storeListByCode', JSON.stringify(this.storeListByCode))
      sessionStorage.setItem('salemanList', JSON.stringify(this.salemanList))
      if (row.tradeStatus === 'APPLY') {
        this.handleTypes = 'audit'
      }
      if (row.tradeStatus === 'AUDITED') {
        this.handleTypes = 'invoice'
      }
      if (row.tradeStatus === 'INVOICED') {
        this.handleTypes = 'cashout'
      }
      this.$router.push({
        path: '/epay/cashoutAudit',
        query: {
          rowDate: JSON.stringify(row),
          handleType: this.handleTypes
        }
      })
    }
  }
}
</script>
<style scoped lang="less">
// @import "index";
@deep: ~">>>";

@{deep} .data-list .el-table tr td {
  height: 40px !important;
  padding: 0 !important;
}
</style>
